import { lazyLoad } from 'utils/loadable';

export const MobileRedirectPage = lazyLoad(
  () => import('./index'),
  module => module.MobileRedirectPage,
);
